import { render } from "./SelectProjectsModal.vue?vue&type=template&id=c7896bdc&scoped=true&ts=true&lang=pug"
import script from "./SelectProjectsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectProjectsModal.vue?vue&type=script&lang=ts&setup=true"

import "./SelectProjectsModal.vue?vue&type=style&index=0&id=c7896bdc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7896bdc"]])

export default __exports__